// DO NOT MOVE - this import overrides default Ionic configuration, and must be setup before the configuration is used in the rendered application.
import './SetupIonicReact';

import './styles';

import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import { config, jobReportShareConfig } from './amplify-config';
import { persistor, store } from './redux/store';
import reportWebVitals from './reportWebVitals';

const pathComponents = window.location.pathname.split('/');

if (
  pathComponents.length > 1 &&
  (pathComponents[1] === 'job-report-share' || pathComponents[1] === 'shared-job-reports')
) {
  Amplify.configure(jobReportShareConfig);
} else {
  Amplify.configure(config);
}

const root = document.getElementById('root')!;

render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Authenticator.Provider>
          <App />
        </Authenticator.Provider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  root,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
